/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import MainNavigation from "@/components/layout/main-navigation";
import { Footer } from "@/components/landing/footer";
import {
  TermlyEmbed,
  TermlyPlaceholder,
} from "@/components/legal/termly-embed";
import Link from "next/link";

const TERMLY_PRIVACY_POLICY_ID = "0e57d7f5-fcdf-4e24-a2d8-af28ce1b46ad";

export function PrivacyPageClient() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <MainNavigation />

      <main className="flex-1">
        <div className="mx-auto max-w-4xl px-4 py-16 md:px-8 lg:py-24">
          <header className="mb-8 text-center">
            <h1 className="mb-4 text-2xl font-bold tracking-tight text-foreground md:text-3xl">
              Privacy Policy
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated: February 2026
            </p>
            <p className="mx-auto mt-4 max-w-2xl text-center text-sm text-muted-foreground">
              Related:{" "}
              <Link href="/legal/sub-processors" className="text-primary underline">
                Sub-processor list
              </Link>
              {" · "}
              <Link href="/legal/acceptable-use" className="text-primary underline">
                Acceptable Use Policy
              </Link>
              {" · "}
              <Link href="/cookies" className="text-primary underline">
                Cookie Policy
              </Link>
            </p>
          </header>

          <div className="prose prose-neutral dark:prose-invert max-w-none">
            {TERMLY_PRIVACY_POLICY_ID ? (
              <TermlyEmbed dataId={TERMLY_PRIVACY_POLICY_ID} />
            ) : (
              <TermlyPlaceholder policyType="Privacy Policy" />
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
